// extracted by mini-css-extract-plugin
export default {"Mobile":"PcItems_Mobile__s2FLd","Main":"PcItems_Main__Bmdd8"};